<div class="main-panel">
    <div class="d-flex">
        <div>
            <div class="mb-1 fw-600">Client Name</div>
            <app-multi-select-dropdown
                id="selectedClient"
                class="multi-select-option form-control shadow-sm multi-select-client"
                [items]="clientList"
                [selectedItems]="selectedClientItems"
                selectedProp="id"
                displayname="name"
                [selectedCountText]="selectedClientCountText"
                [selectedBlankText]="selectedClientBlankText"
                (selectedItemsChange)="onSelectionClientChange($event)"
            ></app-multi-select-dropdown>
        </div>
        <div class="margin-client-search">
            <div class="mb-1 fw-600">User Group</div>
            <app-multi-select-dropdown
                id="selectedUserGroup"
                class="multi-select-option form-control shadow-sm multi-select-client"
                [items]="userGroupList"
                selectedProp="userGroupId"
                displayname="label"
                [selectedItems]="selectedUserGroupItems"
                [selectedCountText]="selectedUserGroupCountText"
                [selectedBlankText]="selectedUserGroupBlankText"
                (selectedItemsChange)="onSelectionUserGroupChange($event)"
            ></app-multi-select-dropdown>
        </div>

        <div class="margin-client-search">
            <div class="d-flex pt-4">
                <div class="h-30p">
                    <input
                        type="text"
                        class="form-control text-box-size shadow-sm client-search-input"
                        placeholder="Search"
                        [attr.id]="'gyan-client-textbox'"
                        [attr.data-test]="'gyan-client-textbox'"
                        [(ngModel)]="searchClientName"
                        (input)="onSearchTextChange()"
                        (keyup.enter)="userSearchList()"
                    />
                    <div class="cursor-pointer clear-icon icon-pos" (click)="clearSearch()" *ngIf="searchClientName !== ''"></div>
                </div>

                <div class="form-control search-client"></div>

                <div class="cursor-pointer search-term-icon" (click)="userSearchList()"></div>
            </div>
        </div>

        <!-- <p>admin-usergroup works!</p> -->
        <div class="d-flex" class="submit-button pt-4">
            <button class="create-button d-flex" (click)="openUserModal(UserModel)">
                <div class="icon-plus"></div>
                <div class="pl-3p">Create User</div>
            </button>
        </div>
    </div>

    <!-- <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center vh-100">
        <div class="p-5">
            <div class="d-flex">
                <div class="padding-summary">Loading...</div>
                <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading">
        <div class="d-flex justify-content-center align-items-center vh-100">
            <div class="p-5">
                <div class="d-flex">
                    <div class="padding-summary">Loading..</div>
                    <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="table-container">
        <div
            [ngClass]="{
                'height-table-div': users?.length == 10,
                'height-table-div-overflow': users?.length < 10 && users?.length <= 4,
            }"
        >
            <table class="custom-table">
                <thead class="custom-table-head">
                    <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">Email ID</th>
                        <th scope="col">User Role</th>
                        <th scope="col">User Group</th>
                        <th scope="col" class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="users?.length > 0">
                        <tr *ngFor="let user of users; let i = index">
                            <td class="col-3" [title]="user.name">
                                {{ user.name.length > 30 ? (user.name | slice: 0 : 30) + '...' : user.name }}
                            </td>
                            <!-- <td title="{{ user.name }}" class="col-3">{{ user.name }}</td> -->
                            <td class="col-3" [title]="user.emailId">
                                {{ user.emailId.length > 30 ? (user.emailId | slice: 0 : 30) + '...' : user.emailId }}
                            </td>
                            <td class="col-2">{{ user.role }}</td>
                            <td class="col-2 ug-name-user" title="{{ user.userGroupName }}">{{ user.userGroupName }}</td>
                            <td class="col-2 text-center">
                                <div class="actions-container">
                                    <fa-icon (click)="togglePopup(i, $event)" class="p-1 cursor-pointer d-flex align-items-center" [icon]="faEllipsisV"> </fa-icon>
                                    <div
                                        *ngIf="activePopupIndex === i"
                                        [ngClass]="{
                                            'popup-menu': !(users.length >= 9 && i >= users.length - 2),
                                            'popup-menu-bottom': users.length >= 9 && i >= users.length - 2,
                                        }"
                                    >
                                        <div class="d-flex cursor-pointer popup-container" (click)="openEditModal(user, UserEditModel)">
                                            <div class="edit-icon"></div>
                                            <div class="popup-item">Edit</div>
                                        </div>

                                        <!-- <div class="popup-item" (click)="deleteGroup(group)">Delete</div> -->
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="!isLoading && users?.length === 0">
                        <td colspan="5" class="text-center no-user-text">No users available with filters applied</td>
                    </tr>
                    <tr *ngIf="isLoading && isFirstTime">
                        <td colspan="5" class="text-center text-secondary">
                            <div class="d-flex justify-content-center align-items-center vh-45">
                                <div class="p-1">
                                    <div class="d-flex">
                                        <div class="padding-summary">Loading..</div>
                                        <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="users?.length > 0" class="pagination" class="d-flex justify-content-between align-items-center">
                <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                <div class="user-pagination pt-2 px-2">
                    <pagination
                        [totalItems]="totalItems"
                        [(ngModel)]="currentPage"
                        [maxSize]="5"
                        class="justify-content-center pagination mb-0 px-0"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                        firstText="&laquo;"
                        lastText="&raquo;"
                        [boundaryLinks]="true"
                        [rotate]="false"
                        (pageChanged)="onPageChanged($event)"
                    >
                    </pagination>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal Template -->
    <ng-template #UserModel let-modal>
        <div>
            <div class="m-0">
                <div class="modal-content text-center">
                    <div class="modal-header fw-600 create-ug-header">
                        <div>Create User</div>
                        <div class="cursor-pointer btn-close close-form" (click)="modal.dismiss('Cross click')"></div>
                    </div>

                    <div class="modal-body ug-form-body">
                        <form (ngSubmit)="onSubmit()" #UserForm="ngForm">
                            <div class="mb-3">
                                <div class="label-form">First Name</div>
                                <input
                                    type="text"
                                    class="form-control shadow-sm ug-form-client"
                                    id="firstname"
                                    [(ngModel)]="firstname"
                                    name="firstname"
                                    required
                                    placeholder="First Name"
                                    required
                                    minlength="1"
                                    #firstnameField="ngModel"
                                    (keypress)="restrictInput($event)"
                                />

                                <div *ngIf="firstnameField?.invalid && firstnameField?.touched">
                                    <div *ngIf="firstnameField?.errors?.['minlength']" class="validation-message">First Name is required.</div>
                                    <div *ngIf="firstnameField?.errors?.['required']" class="validation-message">First Name is required.</div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="label-form">Last Name</div>
                                <input
                                    type="text"
                                    class="form-control shadow-sm ug-form-client"
                                    id="lastname"
                                    [(ngModel)]="lastname"
                                    name="lastname"
                                    required
                                    placeholder="Last Name"
                                    required
                                    minlength="1"
                                    #lastnameField="ngModel"
                                    (keypress)="restrictInput($event)"
                                />

                                <div *ngIf="lastnameField?.invalid && lastnameField?.touched">
                                    <div *ngIf="lastnameField?.errors?.['minlength']" class="validation-message">Last Name is required.</div>
                                    <div *ngIf="lastnameField?.errors?.['required']" class="validation-message">Last Name is required.</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <!-- Email Input Field -->
                                <div class="label-form">Email</div>
                                <div class="loader-input-container">
                                    <input
                                        type="email"
                                        (blur)="verifyEmail()"
                                        class="form-control shadow-sm ug-form-client"
                                        id="email"
                                        [(ngModel)]="email"
                                        (ngModelChange)="validateEmail()"
                                        name="email"
                                        placeholder="Email"
                                        required
                                        #emailField="ngModel"
                                    />

                                    <!-- Loading Spinner -->
                                    <div *ngIf="isLoading" class="spinner-container">
                                        <img class="loader-input-img" src="../../../assets/gifs/loader_wait.gif" alt="Loading..." />
                                    </div>
                                </div>

                                <!-- Validation Error: Required Field -->
                                <div *ngIf="emailField?.touched && emailField?.errors?.['required']" class="validation-message">Email is required.</div>

                                <!-- Validation Error: Backend Error -->
                                <div *ngIf="emailField?.touched && emailError && email.trim() !== ''" class="validation-message">
                                    {{ emailError }}
                                </div>

                                <!-- Success Message: Email Exists -->
                                <div *ngIf="emailField?.touched && isValidUserName && email.trim() !== ''" class="validation-message success">
                                    {{ isValidUserMsg }}
                                </div>

                                <!-- Error Message: Email Does Not Exist -->
                                <div *ngIf="emailField?.touched && !isValidUserName && email.trim() !== ''" class="validation-message error">
                                    {{ isValidUserMsg }}
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="label-form">Gender</div>
                                <div class="select-dropdown">
                                    <select class="form-control ug-form-type" id="gender" [(ngModel)]="gender" name="gender" required #genderField="ngModel" placeholder="Select">
                                        <option value disabled selected>Select Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>

                                <div *ngIf="genderField?.invalid && genderField?.touched">
                                    <div *ngIf="genderField?.errors?.['required']" class="validation-message">Gender is required.</div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="label-form">User Role</div>
                                <div class="select-dropdown">
                                    <select
                                        class="form-control ug-form-type"
                                        id="userRole"
                                        [(ngModel)]="userRole"
                                        name="userRole"
                                        required
                                        #userRoleield="ngModel"
                                        placeholder="Select"
                                    >
                                        <option value disabled selected>Select User Role</option>
                                        <option *ngFor="let userRole of userRoleList" [value]="userRole">{{ userRole }}</option>
                                    </select>
                                </div>

                                <div *ngIf="userRoleield?.invalid && userRoleield?.touched">
                                    <div *ngIf="userRoleield?.errors?.['required']" class="validation-message">User Role is required.</div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="label-form">User Group</div>
                                <div class="select-dropdown">
                                    <select
                                        class="form-control ug-form-type"
                                        id="usergroup"
                                        [(ngModel)]="usergroup"
                                        name="usergroup"
                                        required
                                        #usergroupField="ngModel"
                                        placeholder="Select"
                                    >
                                        <option value disabled selected>Select User Group</option>

                                        <option *ngFor="let group of userGroupAllList" [value]="group.name">{{ group.label }}</option>
                                    </select>
                                </div>

                                <div *ngIf="usergroupField?.invalid && usergroupField?.touched">
                                    <div *ngIf="usergroupField?.errors?.['required']" class="validation-message">User Group is required.</div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end" style="padding-top: 15px">
                                <button type="submit" [disabled]="UserForm.invalid || isValidUserForm" class="create-btn" style="width: 90px">
                                    <span *ngIf="!loading">Create</span>
                                    <span style="display: flex" *ngIf="loading">
                                        <img style="width: 15px !important; height: 15px !important; margin: auto" src="./../assets/gifs/loader_sand.gif" alt="Processing icon" />
                                        <p style="font-size: 10px; margin: auto">Creating..</p></span
                                    >
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Edit User Modal (ng-template) -->
    <ng-template #UserEditModel let-modal>
        <div>
            <div class="m-0">
                <div class="modal-content text-center">
                    <div class="modal-header fw-600 create-ug-header">
                        <div>Edit User</div>
                        <div class="cursor-pointer btn-close close-form" (click)="modal.dismiss('Cross click')"></div>
                    </div>

                    <div class="modal-body ug-form-body">
                        <!-- Form with firstname and Password fields -->
                        <form (ngSubmit)="onUpdateSubmit()" #UserForm="ngForm">
                            <!-- First Name Field -->
                            <div class="mb-3">
                                <div class="label-form">First Name</div>
                                <input
                                    type="text"
                                    class="form-control shadow-sm ug-form-client"
                                    id="firstname"
                                    [(ngModel)]="usersData.firstName"
                                    name="firstname"
                                    required
                                    placeholder="First Name"
                                    minlength="1"
                                    #firstnameField="ngModel"
                                    (ngModelChange)="onFieldChange()"
                                />
                            </div>
                            <div *ngIf="firstnameField?.invalid && firstnameField?.touched">
                                <div *ngIf="firstnameField?.errors?.['minlength']" class="validation-message">First Name is required.</div>
                                <div *ngIf="firstnameField?.errors?.['required']" class="validation-message">First Name is required.</div>
                            </div>

                            <!-- Last Name Field -->
                            <div class="mb-3">
                                <div class="label-form">Last Name</div>
                                <input
                                    type="text"
                                    class="form-control shadow-sm ug-form-client"
                                    id="lastname"
                                    [(ngModel)]="usersData.lastName"
                                    name="lastname"
                                    required
                                    placeholder="Last Name"
                                    minlength="1"
                                    #lastnameField="ngModel"
                                    (ngModelChange)="onFieldChange()"
                                />
                            </div>
                            <div *ngIf="lastnameField?.invalid && lastnameField?.touched">
                                <div *ngIf="lastnameField?.errors?.['minlength']" class="validation-message">Last Name is required.</div>
                                <div *ngIf="lastnameField?.errors?.['required']" class="validation-message">Last Name is required.</div>
                            </div>

                            <!-- Email Field -->
                            <div class="mb-3">
                                <div class="label-form">Email</div>
                                <input
                                    type="email"
                                    class="form-control shadow-sm ug-form-client"
                                    id="email"
                                    [(ngModel)]="usersData.emailId"
                                    name="email"
                                    required
                                    disabled="true"
                                    readonly
                                    placeholder="Email"
                                    (ngModelChange)="validateEmail()"
                                    #emailField="ngModel"
                                />
                            </div>
                            <div *ngIf="emailError" class="validation-message">
                                {{ emailError }}
                            </div>

                            <div class="mb-3">
                                <div class="label-form">Gender</div>
                                <div class="select-dropdown">
                                    <select
                                        class="form-control ug-form-type"
                                        id="gender"
                                        (ngModelChange)="onFieldChange()"
                                        [(ngModel)]="usersData.gender"
                                        name="gender"
                                        required
                                        #genderField="ngModel"
                                        placeholder="Select"
                                    >
                                        <option value disabled selected>Select Gender</option>

                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>

                                <div *ngIf="genderField?.invalid && genderField?.touched">
                                    <div *ngIf="genderField?.errors?.['required']" class="validation-message">Gender is required.</div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="label-form">User Role</div>
                                <div class="select-dropdown">
                                    <select
                                        class="form-control ug-form-type"
                                        id="userRole"
                                        (ngModelChange)="onFieldChange()"
                                        [(ngModel)]="usersData.role"
                                        name="userRole"
                                        required
                                        #userRoleield="ngModel"
                                        placeholder="Select"
                                    >
                                        <option value disabled selected>Select User Role</option>

                                        <option *ngFor="let userRole of userRoleList" [value]="userRole">{{ userRole }}</option>
                                    </select>
                                </div>

                                <div *ngIf="userRoleield?.invalid && userRoleield?.touched">
                                    <div *ngIf="userRoleield?.errors?.['required']" class="validation-message">User Role is required.</div>
                                </div>
                            </div>

                            <!-- User Group Field -->
                            <div class="mb-3">
                                <div class="label-form">User Group</div>
                                <div class="select-dropdown">
                                    <select
                                        class="form-control ug-form-type"
                                        id="usergroup"
                                        [(ngModel)]="usersData.userGroupName"
                                        name="usergroup"
                                        required
                                        #usergroupField="ngModel"
                                        placeholder="Select User Group"
                                        (ngModelChange)="onFieldChange()"
                                    >
                                        <option value disabled>Select User Group</option>
                                        <option *ngFor="let group of userGroupAllList" [value]="group.name">{{ group.label }}</option>
                                    </select>
                                </div>

                                <div *ngIf="usergroupField?.invalid && usergroupField?.touched">
                                    <div *ngIf="usergroupField?.errors?.['required']" class="validation-message">User Group is required.</div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end">
                                <button type="submit" [disabled]="UserForm.invalid" class="create-btn">Save Changes</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Delete Confirmation Modal (ng-template) -->
    <ng-template #deleteModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Confirm Deletion</h4>
            <button type="button" class="btn-close icon-close-admin" (click)="modal.dismiss('Cross click')"></button>
        </div>

        <div class="modal-body">
            <p>Are you sure you want to delete this item?</p>
        </div>

        <div class="modal-footer">
            <button type="button" class="create-btn" (click)="modal.dismiss('Cancel click')">Cancel</button>
            <button type="button" class="create-btn" (click)="confirmDelete(modal)">Confirm</button>
        </div>
    </ng-template>
</div>
